//
//
//
//
//
//
//


export default {"name":"icon-ed1bfd3dc49e91025e16a9b4caf3eda1"}

